import { dbGetAllVideosByMachineId } from '@/db/actions'
import { cloudSyncVideos } from '@/lib/cloud/cloud-sync-videos'
import { useDataStore } from '../../use-data-store'
import { isOnline } from '@/lib/utils/is-online'
import { FILE_READ_CHUNK_SIZE } from '../process-file-chunk'
import { handleFileSyncActions } from '../handle-file-sync-actions'

export const handleFileListVideos = async ({
  machineId,
  files
}: {
  machineId: string
  files: string[]
}) => {
  const sendMachineSyncFilesAction = useDataStore.getState().sendMachineSyncFilesAction

  const fileNamesInMachine = files.filter(f => f.endsWith('.ts'))

  const localDbVideos = await dbGetAllVideosByMachineId(machineId)
  const filesInMachineNotInLocalDb = fileNamesInMachine.filter(
    f => !localDbVideos.find(i => i.fileName === f)
  )
  const filesInMachineInLocalDb = localDbVideos.filter(i => fileNamesInMachine.includes(i.fileName))

  // -------------------------------------------------
  // 1. Schedule file_remove for already synced files
  // -------------------------------------------------
  filesInMachineInLocalDb
    .filter(i => i.shouldDelete === 1)
    .forEach(i => {
      return sendMachineSyncFilesAction({
        in: 'file_remove',
        file: i.fileName
      })
    })

  const filesInMachineInLocalDbNotUploaded = filesInMachineInLocalDb.filter(
    i => i.shouldDelete === 0
  )

  // -------------------------------------------------
  // 2. Sync with Cloud
  // -------------------------------------------------
  const hasInternetConnection = await isOnline()
  if (hasInternetConnection) {
    const filesToSync = [
      ...filesInMachineNotInLocalDb.map(f => ({
        fileName: f,
        hasFile: false
      })),
      ...filesInMachineInLocalDbNotUploaded.map(i => ({
        fileName: i.fileName,
        duration: i.duration,
        hasFile: Boolean(i.hasFile)
      }))
    ]

    const filesWithSyncActions = await cloudSyncVideos(filesToSync)
    if (filesWithSyncActions) {
      await handleFileSyncActions({
        type: 'video',
        filesWithSyncActions
      })
      return
    }
  }

  // -------------------------------------------------
  // 3. If no internet connection, or the sync with cloud didn't work
  // send `file_meta` for videos we don't have in local db
  // send `file_read` for videos we don't have the files
  // -------------------------------------------------

  filesInMachineNotInLocalDb.forEach(f => {
    return sendMachineSyncFilesAction({
      in: 'file_meta',
      file: f
    })
  })

  filesInMachineInLocalDbNotUploaded.forEach(f => {
    if (f.hasFile === 1) return
    return sendMachineSyncFilesAction({
      in: 'file_read',
      file: f.fileName,
      offset: 0,
      count: FILE_READ_CHUNK_SIZE
    })
  })
}
